const Play = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 6.421a1 1 0 0 1 1.545-.838l8.583 5.579a1 1 0 0 1 0 1.676l-8.583 5.58a1 1 0 0 1-1.545-.84zM17.083 12 8.5 6.421V17.58z"
      clipRule="evenodd"
    />
  </>
)
export default Play
